import querystring from "query-string";
import { Epic } from "../rootEpic";
import { filter, switchMap, map, catchError, exhaustMap } from "rxjs/operators";
import { ActionType, isOfType } from "typesafe-actions";
import {
  deleteExcludePortfolioListRequest,
  deleteExcludePortfolioListSuccess,
  deleteExcludePortfolioListFailure,
  fetchPortfoliosSuccess,
} from "./actions";
import {
  FETCH_PORTFOLIOS_BY_ID,
  FETCH_PORTFOLIOS,
  DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST,
} from "./types";
import { EMPTY, forkJoin, of } from "rxjs";

export const fetchPortfoliosEpic: Epic<
  ActionType<typeof fetchPortfoliosSuccess>
> = (action$, _$, { request, config }) =>
  action$.pipe(
    filter(isOfType(FETCH_PORTFOLIOS)),
    switchMap(({ payload }) => {
      console.log("Fetching portfolios with payload:", payload);
      return request({
        method: "GET",
        url: `${
          config.PORTFOLIOS_API_URL
        }/portfolios/customers?${querystring.stringify(payload)}`,
      }).pipe(
        map(({ response }) =>
          fetchPortfoliosSuccess({
            portfolios: response.items,
            count: response.count,
          })
        ),
        catchError(() => EMPTY)
      );
    })
  );

export const fetchPortfolioEpic: Epic<
  ActionType<typeof fetchPortfoliosSuccess>
> = (action$, _$, { request, config }) =>
  action$.pipe(
    filter(isOfType(FETCH_PORTFOLIOS_BY_ID)),
    switchMap(({ payload }) =>
      forkJoin(
        payload.map((portfolioId) =>
          request({
            method: "GET",
            url: `${config.PORTFOLIOS_API_URL}/portfolios/${portfolioId}`,
          })
        )
      ).pipe(
        map((responses) =>
          fetchPortfoliosSuccess({
            portfolios: responses.map((x) => x.response),
            count: responses.length,
          })
        ),
        catchError(() => EMPTY)
      )
    )
  );
export const deleteExcludePortfolioListEpic: Epic<
  | ActionType<typeof deleteExcludePortfolioListRequest>
  | ActionType<typeof deleteExcludePortfolioListSuccess>
  | ActionType<typeof deleteExcludePortfolioListFailure>
> = (action$, _$, { request, config }) =>
  action$.pipe(
    filter(isOfType(DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST)),
    exhaustMap(({ payload }) => {
      const queryParams = (payload as string[])
        .map((id: string) => `portfolioIds=${id}`)
        .join("&");
      const url = `${config.PORTFOLIOS_API_URL}/portfolios/deletesuppresions?${queryParams}`;
      return request({
        method: "DELETE",
        url,
      }).pipe(
        map((response) => {
          if (response.status >= 200 && response.status < 300) {
            return deleteExcludePortfolioListSuccess(payload);
          } else {
            throw new Error("Failed to delete portfolios");
          }
        }),
        catchError((error) => {
          return of(
            deleteExcludePortfolioListFailure(
              error.message || "Failed to delete portfolios"
            )
          );
        })
      );
    })
  );
